import { render, staticRenderFns } from "./QAgentLicensing.vue?vue&type=template&id=45b43ef0&"
import script from "./QAgentLicensing.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QAgentLicensing.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports